/**
 * @generated SignedSource<<6839647d330167da90a9cd94d7d032fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionEditAssigneesPopoverSetAssigneesMutation$variables = {
  employeeIds: ReadonlyArray<string>;
  routineId: string;
  sequenceNumber: number;
};
export type RoutineOccasionEditAssigneesPopoverSetAssigneesMutation$data = {
  readonly routine: {
    readonly occasion: {
      readonly updateAssignedEmployees: {
        readonly assigned: ReadonlyArray<{
          readonly employee: {
            readonly id: string;
          } | null;
        }>;
        readonly id: string;
      };
    };
  } | null;
};
export type RoutineOccasionEditAssigneesPopoverSetAssigneesMutation = {
  response: RoutineOccasionEditAssigneesPopoverSetAssigneesMutation$data;
  variables: RoutineOccasionEditAssigneesPopoverSetAssigneesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sequenceNumber"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "sequenceNumber",
    "variableName": "sequenceNumber"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "employeeIds",
    "variableName": "employeeIds"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineOccasionEditAssigneesPopoverSetAssigneesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "RoutineOccasionMutation",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "updateAssignedEmployees",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignedEmployee",
                    "kind": "LinkedField",
                    "name": "assigned",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineOccasionEditAssigneesPopoverSetAssigneesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "RoutineOccasionMutation",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "updateAssignedEmployees",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignedEmployee",
                    "kind": "LinkedField",
                    "name": "assigned",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3e0269689f0c1de50273136f383115f",
    "id": null,
    "metadata": {},
    "name": "RoutineOccasionEditAssigneesPopoverSetAssigneesMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineOccasionEditAssigneesPopoverSetAssigneesMutation(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $employeeIds: [ID!]!\n) {\n  routine(id: $routineId) {\n    occasion(sequenceNumber: $sequenceNumber) {\n      updateAssignedEmployees(employeeIds: $employeeIds) {\n        id\n        assigned {\n          employee {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4449853c1d00939ecf6bd0c62e40e76";

export default node;
